import { useAppContextStore } from '@src/contexts/AppContextStore'

export function useSSRStatus(statusCode: number | null | undefined) {
  const { contextStore } = useAppContextStore()
  if (typeof window === 'undefined' && statusCode != null && contextStore) {
    contextStore.set('_ssrStatusCode', statusCode)
  }
}
